import '../vendor/TimedPopup.js';
import Cookies from 'js-cookie';

$(document).ready(function() {

    var $activePopupButton = jQuery('#Subscribe');
    var $emailInput = jQuery('#Email');
    var forceOpening = true;

    if(typeof CF !== 'undefined'){
        CF.ready(function() {
            var $formId = $('#create_customer').attr('data-cf-form');
            var $myForm = document.querySelector(`form[data-cf-form="${$formId}"]`);
            var cfForm = $myForm.cfForm;

            $activePopupButton.on('click', function() {
                cfForm.setFieldValue('email', $emailInput.val());

                $('[data-timed-popup="NEWSLETTER_POPUP"]').TimedPopup(forceOpening);
            });

            // Saving cookie
            cfForm.beforeSave(function(){
                Cookies.set('NEWSLETTER_POPUP', 'sent-away', { expires: 7 });
            });

            $myForm.addEventListener('cf:form_submission_failed', function(e){
                console.log(e.detail);
            });
        });
    }
});
